<template>
  <div class="w-auto h-auto collapse navbar-collapse h-100" id="sidenav-collapse-main">
    <ul class="navbar-nav">

      <!-- Dashboard -->
      <li class="nav-item">
        <sidenav-collapse to="/dashboard" activeRoute="dashboard" :navText="$t('dashboard')">
          <template #icon>
            <i class="material-icons-round opacity-10 fs-5">dashboard</i>
          </template>
        </sidenav-collapse>
      </li>

      <!-- Contacts -->
      <li class="nav-item">
        <sidenav-collapse to="/contacts" activeRoute="contacts" :navText="$t('contacts')">
          <template #icon>
            <i class="material-icons-round opacity-10 fs-5">contacts</i>
          </template>
        </sidenav-collapse>
      </li>

      <!-- Orders -->
      <li class="nav-item">
        <sidenav-collapse to="/orders" activeRoute="orders" :navText="$t('orders')">
          <template #icon>
            <i class="material-icons-round opacity-10 fs-5">receipt_long</i>
          </template>
        </sidenav-collapse>
      </li>

      <!-- Abandoned Checkouts -->
      <li class="nav-item">
        <sidenav-collapse to="/abandoned-checkouts" activeRoute="abandoned-checkouts" :navText="$t('abandonedCheckouts')">
          <template #icon>
            <i class="material-icons-round opacity-10 fs-5">remove_shopping_cart</i>
          </template>
        </sidenav-collapse>
      </li>

      <!-- Abandoned Carts -->
      <li class="nav-item">
        <sidenav-collapse to="/abandoned-carts" activeRoute="abandoned-carts" :navText="$t('abandonedCarts')">
          <template #icon>
            <i class="material-icons-round opacity-10 fs-5">shopping_cart_checkout</i>
          </template>
        </sidenav-collapse>
      </li>

      <!-- Bosta returns / exchanges / dashboard-created deliveries -->
      <li class="nav-item">
        <sidenav-collapse to="/bosta-deliveries" activeRoute="bosta-deliveries" :navText="$t('bostaDeliveries')">
          <template #icon>
            <i class="material-icons-round opacity-10 fs-5">assignment_return</i>
          </template>
        </sidenav-collapse>
      </li>

      <!-- Warehouse stock sheet upload -->
      <li class="nav-item">
        <sidenav-collapse to="/warehouse-stock" activeRoute="warehouse-stock" :navText="$t('warehouseStock')">
          <template #icon>
            <i class="material-icons-round opacity-10 fs-5">inventory_2</i>
          </template>
        </sidenav-collapse>
      </li>

      <!-- Delivered Orders report -->
      <li class="nav-item">
        <sidenav-collapse to="/delivered-orders" activeRoute="delivered-orders" :navText="$t('deliveredOrders')">
          <template #icon>
            <i class="material-icons-round opacity-10 fs-5">local_shipping</i>
          </template>
        </sidenav-collapse>
      </li>

      <!-- Blocked Contacts -->
      <li class="nav-item">
        <sidenav-collapse to="/blocked-contacts" activeRoute="blocked-contacts" :navText="$t('blockedContacts')">
          <template #icon>
            <i class="material-icons-round opacity-10 fs-5">block</i>
          </template>
        </sidenav-collapse>
      </li>

      <!-- WhatsApp Conversations -->
      <li class="nav-item">
        <sidenav-collapse to="/whatsapp-conversations" activeRoute="whatsapp-conversations" :navText="$t('whatsappConversations')">
          <template #icon>
            <i class="material-icons-round opacity-10 fs-5">chat</i>
          </template>
        </sidenav-collapse>
      </li>

      <!-- Testimonials -->
      <li class="nav-item">
        <sidenav-collapse to="/testimonials" activeRoute="testimonials" :navText="$t('testimonials')">
          <template #icon>
            <i class="material-icons-round opacity-10 fs-5">forum</i>
          </template>
        </sidenav-collapse>
      </li>

      <!-- Blogs -->
      <li class="nav-item">
        <sidenav-collapse to="/blogs" activeRoute="blogs" :navText="$t('blogs')">
          <template #icon>
            <i class="material-icons-round opacity-10 fs-5">article</i>
          </template>
        </sidenav-collapse>
      </li>

      <!-- Categories Group -->
      <li class="nav-item">
        <sidenav-collapse :navText="$t('categories')" :children="[
          { to: '/categories', navText: $t('categories'), activeRoute: 'categories', icon: 'category' },
          { to: '/sub-categories', navText: $t('subCategories'), activeRoute: 'sub-categories', icon: 'subdirectory_arrow_right' },
        ]">
          <template #icon>
            <i class="material-icons-round opacity-10 fs-5">layers</i>
          </template>
        </sidenav-collapse>
      </li>

      <!-- Products Group -->
      <li class="nav-item">
        <sidenav-collapse :navText="$t('productsManagement')" :children="[
          { to: '/products', navText: $t('products'), activeRoute: 'products', icon: 'inventory_2' },
          { to: '/products/needs-manufacturing', navText: $t('needsManufacturing'), activeRoute: 'needs-manufacturing', icon: 'precision_manufacturing' },
          { to: '/products/inventory', navText: $t('inventory'), activeRoute: 'inventory', icon: 'inventory' },
          { to: '/product-set-items', navText: $t('featuredSets'), activeRoute: 'product-set-items', icon: 'star' },
          { to: '/collections', navText: $t('collections'), activeRoute: 'collections', icon: 'collections_bookmark' },
          { to: '/promo-codes', navText: $t('promoCodes'), activeRoute: 'promo-codes', icon: 'sell' },
          { to: '/fit-profiles', navText: $t('fitProfiles'), activeRoute: 'fit-profiles', icon: 'straighten' },
          { to: '/soles', navText: $t('soles'), activeRoute: 'soles', icon: 'foundation' },
          { to: '/products/option-types', navText: $t('optionTypes'), activeRoute: 'option-types', icon: 'settings' },
        ]">
          <template #icon>
            <i class="material-icons-round opacity-10 fs-5">inventory_2</i>
          </template>
        </sidenav-collapse>
      </li>

      <!-- Website Content -->
      <li class="nav-item">
        <sidenav-collapse :navText="$t('websiteContent')" :children="[
          { to: '/banners', navText: $t('banners'), activeRoute: 'banners', icon: 'view_carousel' },
          { to: '/static-pages', navText: $t('staticPages'), activeRoute: 'static-pages', icon: 'pages' },
        ]">
          <template #icon>
            <i class="material-icons-round opacity-10 fs-5">web</i>
          </template>
        </sidenav-collapse>
      </li>

      <li class="nav-item">
        <sidenav-collapse to="/trash" activeRoute="trash" :navText="$t('trashRestore')">
          <template v-slot:icon>
            <i class="material-icons-round opacity-10 fs-5">restore_from_trash</i>
          </template>
        </sidenav-collapse>
      </li>

      <!-- Locations Group -->
      <li class="nav-item">
        <sidenav-collapse :navText="$t('locations')" :children="[
          { to: '/countries', navText: $t('countries'), activeRoute: 'countries', icon: 'public' },
          { to: '/cities', navText: $t('cities'), activeRoute: 'cities', icon: 'location_city' },
          { to: '/districts', navText: $t('districts'), activeRoute: 'districts', icon: 'location_on' },
        ]">
          <template #icon>
            <i class="material-icons-round opacity-10 fs-5">travel_explore</i>
          </template>
        </sidenav-collapse>
      </li>

      <li class="nav-item">
        <sidenav-collapse :navText="$t('email')" :children="[
          { to: '/sendEmail', navText: $t('sendEmail'), activeRoute: 'sendEmail', icon: 'email' },
          { to: '/subscribers', navText: $t('subscribers'), activeRoute: 'inbox', icon: 'email' },
        ]">
          <template #icon>
            <i class="material-icons-round opacity-10 fs-5">email</i>
          </template>
        </sidenav-collapse>
      </li>
    </ul>
  </div>
</template>

<script>
import SidenavCollapse from "./SidenavCollapse.vue";

export default {
  name: "SidenavList",
  components: {
    SidenavCollapse,
  },
};
</script>
